import { Grid, Typography } from "@mui/material";

//import images
import exampleImage from "../../../../assets/imgs/tour-example.png";
import doctorsImage from "../../../../assets/imgs/Amir Sabzevari.jpg";
import "./treatment-information.scss";
import { t } from "i18next";

function TreatmentInformation({ medicalInfos }) {
    if (!medicalInfos || medicalInfos.length === 0) {
        // Return a message or a placeholder when there's no data
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ height: "100px" }}>
                <Typography>No treatment information available.</Typography>
            </Grid>
        );
    }

    const firstInfo = medicalInfos[0];

    return (
        // <Grid className="treatment-information" container item xs={12} rowGap={3} justifyContent="space-between">
        //     <Grid className="treatment-information__medical-center" container item md={2} rowGap={1} direction="column" alignItems="center">
        //         <img src={exampleImage} alt="TreatmentInformation" />
        //         <span className="treatment-information__medical-center-name">{firstInfo.clinic.name}</span>
        //     </Grid>
        //     <Grid className="treatment-information__doctor-information" container item md={2.5} direction="column" alignItems="center">
        //         <img src={doctorsImage} alt="" />
        //         <span className="treatment-information__doctor-name">
        //             {firstInfo.doctor.first_name}
        //             {firstInfo.doctor.last_name}
        //         </span>
        //         {firstInfo.doctor.specialty}
        //         <span> </span>
        //     </Grid>

        //     <Grid container item md={6}>
        //         <span>{t("description")}</span>
        //         <p className="treatment-information__description">{firstInfo.clinic.description}</p>
        //     </Grid>
        // </Grid>
        <Grid container spacing={3}>
            {medicalInfos.map((info, index) => (
                <Grid item xs={12} key={index}>
                    <Grid className="treatment-information" container item xs={12} rowGap={3} justifyContent="space-between">
                        <Grid
                            className="treatment-information__medical-center"
                            container
                            item
                            md={2}
                            rowGap={1}
                            direction="column"
                            alignItems="center"
                        >
                            <img src={exampleImage} alt="TreatmentInformation" />
                            <span className="treatment-information__medical-center-name">{info.clinic.name}</span>
                        </Grid>
                        <Grid className="treatment-information__doctor-information" container item md={2.5} direction="column" alignItems="center">
                            <img src={doctorsImage} alt="" />
                            <span className="treatment-information__doctor-name">
                                {info.doctor.first_name} {info.doctor.last_name}
                            </span>
                            <span>{info.doctor.specialty}</span>
                        </Grid>
                        <Grid container item md={6}>
                            <span>{t("description")}: </span>
                            <p className="treatment-information__description">{info.clinic.description}</p>
                        </Grid>
                    </Grid>
                    {index < medicalInfos.length - 1 && <hr className="treatment-information__divider" />}
                </Grid>
            ))}
        </Grid>
    );
}

export default TreatmentInformation;
